export default {
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'YlHotelProductList', title: '同步产品' },
      { name: 'YlHotelOrderList', title: '订单直连' },
      { name: 'YlHotelApiConfigure', title: 'API配置' },
      { name: 'YlHotelSyncRule', title: '同步规则' }
    ])
  }
}
